import { Fragment, FunctionComponent } from "react";
import { observer } from "mobx-react-lite";

import { ConfirmDialog } from "primereact/confirmdialog";

import { CallableToast } from "./CallableToast/CallableToast";

const GlobalPrimeReactDefinitionsRaw: FunctionComponent = () => {
  return (
    <Fragment>
      <ConfirmDialog />

      <CallableToast />
    </Fragment>
  );
};

export const GlobalPrimeReactDefinitions = observer(GlobalPrimeReactDefinitionsRaw);
